import { $fetch as _$fetch } from 'ofetch'
import { baseURL } from '#internal/nuxt/paths'
if (!globalThis.$fetch) {
  globalThis.$fetch = _$fetch.create({
    baseURL: baseURL()
  })
}
export const $fetch = globalThis.$fetch